module.exports = __webpack_public_path__ + "static/media/details-1-image-8.991fe5b5.jpg";